module.exports = __webpack_public_path__ + "static/media/feedback-right-wireframe.6dfd4e15.svg";